import { ASSETGUARD_ACCESS_RIGHTS } from "@/constants/AccessRights";

export var assetGuardMenuItems = [
    {
        id: "assetguard",
        label: "Asset Guard",
        icon: "ri-stack-line",
        link: "/#",
        subItems: [
            {
                id: "assetguard-dashboard-admin", label: "Admin Dashboard",
                icon: "ri-bar-chart-2-fill", link: "/assetguard/admin-dashboard", parentId: "assetguard",
                permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_ADMIN_DASHBOARD]
            },
            {
                id: "assetguard-dashboard-employee", label: "Employee Dashboard",
                icon: "ri-bar-chart-2-fill", link: "/assetguard/employee-dashboard", parentId: "assetguard",
                permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_EMPLOYEE_DASHBOARD]
            },
            {
                id: "assetguard-my-assets", label: "My Assets",
                icon: "ri-user-settings-line", link: "/assetguard/my-assets", parentId: "assetguard",
                permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_MYASSETS]
            },
            {
                id: "assetguard-assets", label: "Assets Masterlist",
                icon: "ri-archive-drawer-line", link: "/assetguard/assets", parentId: "assetguard",
                permissionTypeId: [ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_ASSETS]
            },

            // ── Transactions (admin-facing) ──────────────────────────────
            {
                id: "assetguard-transactions", label: "Transactions",
                icon: "ri-swap-box-line", link: "/assetguard/transactions", parentId: "assetguard",
                permissionTypeId: [
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_REQUESTOR,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_AGENCYTRANSFERS_APPROVER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_REQUESTOR,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_APPROVER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_REQUESTOR,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_APPROVER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_REQUESTOR,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_APPROVER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_REQUESTOR,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETISSUANCES_APPROVER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_REQUESTOR,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_APPROVER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_REQUESTOR,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_APPROVER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_REQUESTOR,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_APPROVER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_STOLENASSETS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_STOLENASSETS_REQUESTOR,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_STOLENASSETS_APPROVER,
                ]
            },

            // ── Others (employee-facing) ─────────────────────────────────
            {
                id: "assetguard-asset-requests", label: "Asset Request",
                icon: "ri-article-line", link: "/assetguard/others/asset-requests", parentId: "assetguard",
                permissionTypeId: [
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREQUESTS_REQUESTOR,
                ]
            },
            {
                id: "assetguard-asset-transfers", label: "Asset Transfer",
                icon: "ri-article-line", link: "/assetguard/others/asset-transfers", parentId: "assetguard",
                permissionTypeId: [
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETTRANSFERS_REQUESTOR,
                ]
            },
            {
                id: "assetguard-asset-auctions", label: "Asset Auctions",
                icon: "ri-article-line", link: "/assetguard/others/asset-auctions", parentId: "assetguard",
                permissionTypeId: [
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETAUCTIONS_REQUESTOR,
                ]
            },
            {
                id: "assetguard-asset-decommissions", label: "Asset Decommissions",
                icon: "ri-article-line", link: "/assetguard/others/asset-decommissions", parentId: "assetguard",
                permissionTypeId: [
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDECOMMISSIONS_REQUESTOR,
                ]
            },
            {
                id: "assetguard-asset-disposals", label: "Asset Disposal",
                icon: "ri-article-line", link: "/assetguard/others/asset-disposals", parentId: "assetguard",
                permissionTypeId: [
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETDISPOSALS_REQUESTOR,
                ]
            },
            {
                id: "assetguard-asset-repairs", label: "Asset Repairs",
                icon: "ri-article-line", link: "/assetguard/others/asset-repairs", parentId: "assetguard",
                permissionTypeId: [
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_ASSETREPAIRS_REQUESTOR,
                ]
            },
            {
                id: "assetguard-stolen-assets", label: "Stolen Assets",
                icon: "ri-article-line", link: "/assetguard/others/stolen-assets", parentId: "assetguard",
                permissionTypeId: [
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_STOLENASSETS_VIEWER,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_TRANSACTIONS_STOLENASSETS_REQUESTOR,
                ]
            },

             {
                id: "assetguard-reports", label: "Reports",
                icon: "ri-article-line", link: "/assetguard/reports", parentId: "assetguard",
                permissionTypeId: []
            },

            {
                id: "assetguard-settings", label: "Settings",
                icon: "ri-settings-2-fill", link: "/assetguard/settings", parentId: "assetguard",
                permissionTypeId: [
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_GOVAGENCIES,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_AGENCIYTRANSFERBASIS,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_ASSETARTICLES,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_ASSETGROUPS,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_ASSETTYPES,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_GOVDEPARTMENTS,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_DOCUMENTTYPES,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_MAINTENANCETYPES,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_RETURNREASONS,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_SERVICEPROVIDERS,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_STORAGELOCATIONS,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_TRANSFERREASONS,
                    ASSETGUARD_ACCESS_RIGHTS.ASSETGUARD_STATICDATA_UNITOFMEASURES,
                ]
            },
        ],
    },
];